
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GuessList extends Vue {
    get guessMessageList() {
        const guessList: any[] = this.$store.getters.getGuessList();
        const guessMessageList = guessList.map((v, i) => Object.assign(v, {
            index: i + 1,
            x: 0,
            y: 20 * i,
        }));

        return guessMessageList;
    }

    get hasWon() {
        return this.$store.getters.hasWon();
    }
}
